module.exports = __webpack_public_path__ + "static/media/t32.999e98d2.jpg";